import { createAsyncThunk } from "@reduxjs/toolkit";
import { corporateClientAPI } from "../api/corporateClientApi";
import { getCorporateClientName } from "../types/corporateClientTypes";
import { toast } from "react-toastify";

export const getCorporateClientNamesByMarathonId = createAsyncThunk<
  getCorporateClientName[],
  number,
  { rejectValue: string }
>(
  "admin/getCorporateClientNamesByMarathonId",
  async (marathonId, { rejectWithValue }) => {
    try {
      const response = await corporateClientAPI.getCorporateClientNamesByMarathonId(marathonId);
      return response.data;
    } catch (error: any) {
      const errorMessage = error instanceof Error ? error.message : 'Ошибка на сервере';
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);
